import {useContext, useState} from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Modal from "../../components/Modal.js";
import Switch from "../../components/Switch.js";
import ModalDisableElementForm from "./ModalDisableElementForm.js";
import ComponentServiceStateHistory from "../../components/ComponentServiceStateHistory.js";

import {SettingsContext} from "../../contexts/settings.js";
import {AuthContext} from "../../contexts/auth.js";
import {FacilityNavContext} from "../../contexts/facilitynav.js";

import useApi from "../../hooks/useApi.js";

import {pad, status} from "../../style/components/variables.js";
import {HeadingCenter} from "../../style/components/general.js";

const ModalElementDisabledHistory = ({
  visible,
  setVisible,
  goBack,
  target,
  checksheetId,
  facilitySlug,
  allowStateChange = true
}) => {
  const {settings} = useContext(SettingsContext);
  const {roleCanAccessResource, currentUser} = useContext(AuthContext);
  const {facility} = useContext(FacilityNavContext);

  const [stateChangeVisible, setStateChangeVisible] = useState(false);

  const {api} = useApi("facilities");

  const handleDisableElement = note => {
    api
      .callPut(facility.id, {
        stateChange: {
          [target.name]: {
            disabled: !target.state?.disabled,
            user: currentUser.publicId,
            userLabel: `${currentUser.firstName} ${currentUser.lastName}`,
            time: Date.now(),
            explanation: note
          }
        }
      })
      .then(response => {
        if (response.status === 200) {
          setStateChangeVisible(false);
        }
      });
  };

  if (stateChangeVisible)
    return (
      <ModalDisableElementForm
        visible={stateChangeVisible}
        disabled={!!target.state?.disabled}
        setVisible={state => {
          if (!state) setStateChangeVisible(false);
        }}
        target={target}
        submitNote={note => {
          handleDisableElement(note);
        }}
        cancel={() => setStateChangeVisible(false)}
        requireNote
        goBack={() => setStateChangeVisible(false)}
        showHistory={false}
      />
    );

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
      hasBackButton={!!goBack}
      goBack={goBack}
      renderModalControls={
        allowStateChange && roleCanAccessResource("facility_checksheet_record", "create") ? (
          <Switch
            on={target.enabledLabel || "In Service"}
            off={target.disabledLabel || "Out of Service"}
            state={!target.state?.disabled}
            callback={() => setStateChangeVisible(true)}
            onColor={status.success}
            offColor={status.error}
            syncState
          />
        ) : undefined
      }>
      <ModalTitle>{target.label} Service State History</ModalTitle>
      <ComponentServiceStateHistory
        stateHistory={target.stateHistory}
        enabledLabel={target.enabledLabel}
        disabledLabel={target.disabledLabel}
        facilitySlug={facilitySlug}
        checksheetId={checksheetId}
        timezone={settings?.timezone}
        variant="accordion"
        emptyCentered
      />
    </Modal>
  );
};

ModalElementDisabledHistory.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  goBack: PropTypes.func,
  target: PropTypes.objectOf(PropTypes.any).isRequired,
  checksheetId: PropTypes.number,
  facilitySlug: PropTypes.string,
  allowStateChange: PropTypes.bool
};

const ModalTitle = styled(HeadingCenter)`
  margin-bottom: ${pad * 2}px;
`;

export default ModalElementDisabledHistory;
